










































































import { Vue, Component, Prop } from 'vue-property-decorator';
import AfterSignCreateSignup from '@signing-page/signing/components/modals/signup-after-sign/AfterSignCreateSignup.vue';
import AfterSignFeedback from '@signing-page/signing/components/modals/signup-after-sign/AfterSignFeedback.vue';
import AfterSignOptions from '@signing-page/signing/components/modals/signup-after-sign/AfterSignOptions.vue';
import AfterSignFeedbackComplete from '@signing-page/signing/components/modals/signup-after-sign/AfterSignFeedbackComplete.vue';
import AfterSignCreateSignupComplete from '@signing-page/signing/components/modals/signup-after-sign/AfterSignCreateSignupComplete.vue';
import { EAfterSignStep } from '@signing-page/signing/types/enums/after-sign-step';
import { IRecipient } from '@signing-page/documents/types/recipient';
import Icon from '@/components/Icon.vue';
import Button from '@/components/Button.vue';
import { EButtonTypes } from '@/enums/ButtonType';
import { validateEmail } from '@/common/helpers';
import { IAfterSign } from '@signing-page/signing/types/after-sign';

@Component({
  components: {
    AfterSignCreateSignup,
    AfterSignFeedback,
    AfterSignOptions,
    AfterSignFeedbackComplete,
    AfterSignCreateSignupComplete,
    Icon,
    Button,
  },
  data: () => ({
    EAfterSignStep,
    EButtonTypes,
  }),
})
export default class AfterSign extends Vue {
  @Prop() recipient!: IRecipient;
  @Prop() afterSign!: IAfterSign;

  emailInput = '';
  feedbackInput = '';

  get showActionButtons(): boolean {
    return (
      this.currentStep !== EAfterSignStep.Init &&
      this.currentStep !== EAfterSignStep.FeedbackComplete
    );
  }

  get validEmail(): boolean {
    return this.emailInput.length > 0 && validateEmail(this.emailInput);
  }

  get recipientEmail(): string {
    return this.recipient.email || '';
  }

  get showCancelButton(): boolean {
    return (
      this.currentStep !== EAfterSignStep.SignupComplete &&
      this.currentStep !== EAfterSignStep.FeedbackComplete
    );
  }

  get currentStep(): EAfterSignStep {
    return this.afterSign.step;
  }

  handleChangeStep(step: EAfterSignStep) {
    this.$emit('changeStep', step);
  }

  handleSelect(option: EAfterSignStep) {
    this.handleChangeStep(option);
    this.$emit('response', option);
  }

  handleEmail(email: string) {
    this.emailInput = email;
  }

  handleFeedback(feedback: string) {
    this.feedbackInput = feedback;
  }

  handleSendFeedback() {
    this.$emit('feedback', this.feedbackInput, this.recipientEmail);
    this.handleChangeStep(EAfterSignStep.FeedbackComplete);
  }

  handleSignup() {
    this.$emit('signup', this.emailInput);
  }

  handleClose() {
    this.$emit('close');
  }

  mounted() {
    this.emailInput = this.recipientEmail;
  }
}
